'use strict';

export function getStaticFeatureFlag(_name) {
  return false;
}
export function setDynamicFeatureFlag(_name, _value) {
  // no-op
}
export function getDynamicFeatureFlag(_name) {
  return false;
}
//# sourceMappingURL=featureFlags.js.map